import { c as _c } from "react/compiler-runtime";
import { FlexContainer } from './FlexContainer';
import { Skeleton } from './Skeleton';
import type { TabsOrientation } from './Tabs';
interface DetailPageSkeletonProps {
  children: React.ReactNode;
  tabs?: number;
  showBackLink?: boolean;
  tabsOrientation?: TabsOrientation;
}

/**
 * Loading shell for entity detail pages: back link, heading, optional tab
 * strip, then the page-specific card skeletons as children.
 */
export function DetailPageSkeleton(t0) {
  const $ = _c(10);
  const {
    children,
    tabs: t1,
    showBackLink: t2,
    tabsOrientation: t3
  } = t0;
  const tabs = t1 === undefined ? 0 : t1;
  const showBackLink = t2 === undefined ? true : t2;
  const tabsOrientation = t3 === undefined ? "horizontal" : t3;
  let t4;
  if ($[0] !== showBackLink) {
    t4 = showBackLink && <Skeleton height={14} width={120} />;
    $[0] = showBackLink;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton height={36} width={250} />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== children || $[4] !== tabs || $[5] !== tabsOrientation) {
    t6 = tabs > 0 && tabsOrientation === "vertical" ? <FlexContainer className="gap-4" items="start"><FlexContainer className="w-56 shrink-0 gap-2" direction="column" items="stretch">{Array.from({
          length: tabs
        }).map(_temp)}</FlexContainer><div className="min-w-0 flex-1">{children}</div></FlexContainer> : <>{tabs > 0 && <FlexContainer className="gap-4">{Array.from({
          length: tabs
        }).map(_temp2)}</FlexContainer>}{children}</>;
    $[3] = children;
    $[4] = tabs;
    $[5] = tabsOrientation;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <FlexContainer className="gap-6" direction="column" items="stretch">{t4}{t5}{t6}</FlexContainer>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp2(__0, i_0) {
  return <Skeleton height={32} key={i_0} width={80} />;
}
function _temp(_, i) {
  return <Skeleton height={32} key={i} width="100%" />;
}